import ComingSoon from './ComingSoon';

/**
 * DeepVariant is not implemented yet.
 *
 * The previous contents were a non-functional mockup (a hardcoded reference-genome
 * dropdown and a fake progress timer) and were removed. This route is intercepted by
 * PipelineGate in App.tsx, so the placeholder below renders only without that gate.
 */
const DeepVariant = () => <ComingSoon title="DeepVariant" />;

export default DeepVariant;
